import React from 'react';

function ApplicationHome(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-60.000000, -190.000000)">
          <g transform="translate(8.000000, 146.000000)">
            <g transform="translate(52.000000, 44.000000)" fill="#FFFFFF">
              <polygon id="Path-89-Copy-2" opacity="0.5" points="10 7.5 1.5 14.5 14 19 22.5 12" />
              <polygon id="Path-89-Copy" points="10 4.5 1.5 11.5 14 16 22.5 9" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default ApplicationHome;
